import InputTypesEnum from '../Enums/InputTypesEnum';
import AuthService from '../Services/authService';
import SearchParamsBase from './SearchParamsBase';

export default class UserLinkSearchParams extends SearchParamsBase {
  // HasUserLinkAdminRole is a UI-permission flag (used only in field hide logic),
  // not filter data, so it is excluded from the serialized request (see SearchParamsBase).
  fieldsToExcludeFromSerialization() {
    return ['HasUserLinkAdminRole'];
  }

  initialize() {
    this.AsSassieAsgnId = '';
    this.SelectedUserId = '';
    this.HasUserLinkAdminRole = AuthService.HasRole('UserLinkAdmin');
    this.OnlyHomePageLinks = false;
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'IsActive',
      label: 'Active?',
      className: 'col-3',
      type: InputTypesEnum.Checkbox,
    },
    {
        fieldName: "SelectedUserId",
        label: "User",
        className: "col-6",
        type: InputTypesEnum.UserSelect,
        hide: (searchItem) => searchItem.HasUserLinkAdminRole,
      }
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'UserLinkSearchParams';
}
